// @ts-check

/** @file Defines the basic local User shell and associations. */

import UserBase from "../model-bases/user.js"
import localDatabaseModel from "../database/local-database-model.js"

/** Basic display-only user row in the local application replica. */
const UserModel = localDatabaseModel(UserBase)

export default UserModel
